function appendArray(
  searchParams: URLSearchParams,
  key: string,
  array: string[],
) {
  for (const item of array) {
    searchParams.append(`${key}[]`, item);
  }
}

export function getQueryParamsFromArray(
  path: string,
  key: string,
  params: (string | Record<string, string[]>)[] | undefined | null,
) {
  if (!params || params.length === 0) {
    return path;
  }
  // This is a workaround because directus does not build the query parameters for arrays correctly
  const urlSearchParams = new URLSearchParams();
  for (const param of params) {
    if (typeof param === 'object') {
      for (const [objectKey, objectValue] of Object.entries(param)) {
        appendArray(
          urlSearchParams,
          key,
          objectValue.map((value) => `${objectKey}.${value}`),
        );
      }
    } else {
      urlSearchParams.append(`${key}[]`, param);
    }
  }
  return path + '?' + urlSearchParams.toString();
}

export function addQueryParams(
  path: string,
  params: Record<string, string | number>,
) {
  if (Object.keys(params).length === 0) {
    return path;
  }

  const urlSearchParams = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    urlSearchParams.append(key, String(value));
  }
  return path + '?' + urlSearchParams.toString();
}

export function getArrayParams(
  arrayParams: Record<string, string[] | undefined>,
) {
  const urlSearchParams = new URLSearchParams();
  for (const [key, values] of Object.entries(arrayParams)) {
    if (values && values.length > 0) {
      for (const value of values) {
        urlSearchParams.append(`${key}[]`, value);
      }
    }
  }
  return urlSearchParams.toString();
}
